import React, { useState, useContext } from "react";
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DatePickerComponent from '../../components/DatePickerComponent';
import Dashboard from '../../components/Dashboard';
import { CubeJSContext } from '../../context/CubeJSProvider';
import OmnitechQueries from '../../queries/OmnitechQueries'
import PageHeaderComponent from '../../components/PageHeaderComponent';
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { format } from 'date-fns'

const applyFilter = (query, storeFilter, languageFilter) => {
  let storeCodeFilterObj = {
    member: "VoidedCartLineProperties.storeCode",
    operator: "equals",
    values: storeFilter
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }

  let locateFilterObj = {
    member: "ProductTranslations.locale",
    operator: "equals",
    values: [languageFilter]
  }
  query = {
      ...query,
      filters: (query.filters || []).concat(locateFilterObj)
    }

  return query
}

const VoidItemDetailHistQuery = (storeFilter, startDateFilter, endDateFilter, languageFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  
  let item = {
    name: t('page.fnb.voidItemDetail.name'),
    tableHeaders: {
      "VoidedCartLineProperties.skuCode": { name: t('page.fnb.voidItemDetail.tableHeader.skuCode'), type: 'string'},
      "VoidedCartLineProperties.skuInternalUseTitle": { name: t('page.fnb.voidItemDetail.tableHeader.sukTitle'), type: 'string'},
      "VoidedCartLineProperties.productCode": { name: t('page.fnb.voidItemDetail.tableHeader.productCode'), type: 'string'},
      "ProductTranslations.title": { name: t('page.fnb.voidItemDetail.tableHeader.productTitle'), type: 'string'},
      "VoidedCartLineProperties.productType": { name: t('page.fnb.voidItemDetail.tableHeader.productType'), type: 'string'},
      "VoidedCartLineProperties.storeCode": { name: t('page.fnb.voidItemDetail.tableHeader.storeCode'), type: 'string'},
      "VoidedCartLineProperties.sumQuantity": { name: t('page.fnb.voidItemDetail.tableHeader.quantity'), type: 'number'},
    },
    grid: {xs: 12},
    export: { allowExport: true, filename: 'void_item_detail_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.voidedCartLineProperties.VoidItemDetail.query,
    "timeDimensions": [
      {
        "dimension": "VoidedCartLineProperties.softDeletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, languageFilter)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const VoidItemDetailHistPage = () => {
  const { t, i18n } = useTranslation();
  let languageFilter = i18n.language
  if(languageFilter !== 'en-HK' && languageFilter !== 'zh-HK')
    languageFilter = 'en-HK'
  const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeFilter, setStoreFilter ] = useState([]);
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);

  const { item, result }  = VoidItemDetailHistQuery(storeFilter, startDateFilter, endDateFilter, languageFilter, refresh1, setRefresh1)

  const refresh = () => {
    setRefresh1(true)
    setPage(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.voidItemDetailReport')} />,
    <Dashboard>
      <MultiSelectComponent id={"store_code_filter"} state={storeFilter} pageChangerArr={[setPage]}
          stateChanger={setStoreFilter} textLabel={t('page.fnb.voidItemDetail.filter.store.name')} selectArray={storeCodeSelect}/>
      <DatePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter} dateLabel={t('page.fnb.voidItemDetail.filter.softDeleteAt.date')}/>
    </Dashboard>,
    <Dashboard>
      <TableComponent item={item} result={result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}/>
    </Dashboard>
  ]) 
};

export default VoidItemDetailHistPage;